import clsx from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
// Our Tailwind v4 @theme defines custom text-size tokens (text-caption / text-body /
// text-card / text-section / text-page / text-stat — see styles/main.css). Vanilla
// tailwind-merge doesn't know them, so it lumps e.g. `text-body` (a font size) into the
// same conflict group as `text-white` (a color) and drops the earlier one — which left
// every primary/danger/success/ai BaseButton with invisible text (color fell back to the
// dark --color-fg). Registering the tokens as font-size keeps color + size independent.
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: ['caption', 'body', 'card', 'section', 'page', 'stat'] }],
        },
    },
});
export const cn = (...inputs) => twMerge(clsx(inputs));
